import React from "react"
import { useStaticQuery, graphql } from "gatsby"

import { TypeTitle, TypeDescription, CardRow } from "./Card"
import Flavor from "./Flavor"

import {
  pbCup,
  cookiesCream,
  chocolateChill,
  vanillaBliss,
  cottonCandy,
} from "../../data/milkshakeDataEn"

export default function EnglishMilkshakes(props) {
  const { activeFlavor, setActiveFlavor, incomingFlavor } = props

  const images = useStaticQuery(graphql`
    query flavorsMilkshakes {
      pbCup: file(
        relativePath: { eq: "front-page-flavors/milkshake-pb-cup-can.png" }
      ) {
        childImageSharp {
          fixed(height: 300) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }

      cookiesCream: file(
        relativePath: {
          eq: "front-page-flavors/milkshake-cookies-cream-can.png"
        }
      ) {
        childImageSharp {
          fixed(height: 300) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }

      chocolateChill: file(
        relativePath: { eq: "front-page-flavors/milkshake-chocolate-can.png" }
      ) {
        childImageSharp {
          fixed(height: 300) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }

      vanillaBliss: file(
        relativePath: { eq: "front-page-flavors/milkshake-vanilla-can.png" }
      ) {
        childImageSharp {
          fixed(height: 300) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }

      cottonCandy: file(
        relativePath: {
          eq: "front-page-flavors/milkshake-cotton-candy-can.png"
        }
      ) {
        childImageSharp {
          fixed(height: 300) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }
    }
  `)

  return (
    <>
      <TypeTitle>Milkshakes</TypeTitle>
      <TypeDescription>
        Get excited about six delicious core flavors that are made with real
        milk. Plus, our limited edition flavors released each year!
      </TypeDescription>

      <CardRow>
        <Flavor
          data={cookiesCream}
          fixed={images.cookiesCream.childImageSharp.fixed}
          flavorIndex={1}
          activeFlavor={activeFlavor}
          setActiveFlavor={setActiveFlavor}
          incomingFlavor={incomingFlavor}
        />

        <Flavor
          data={vanillaBliss}
          fixed={images.vanillaBliss.childImageSharp.fixed}
          flavorIndex={2}
          activeFlavor={activeFlavor}
          setActiveFlavor={setActiveFlavor}
          incomingFlavor={incomingFlavor}
        />
        <Flavor
          data={chocolateChill}
          fixed={images.chocolateChill.childImageSharp.fixed}
          flavorIndex={3}
          activeFlavor={activeFlavor}
          setActiveFlavor={setActiveFlavor}
          incomingFlavor={incomingFlavor}
        />
      </CardRow>

      <CardRow>
        <Flavor
          data={cottonCandy}
          fixed={images.cottonCandy.childImageSharp.fixed}
          flavorIndex={4}
          activeFlavor={activeFlavor}
          setActiveFlavor={setActiveFlavor}
          incomingFlavor={incomingFlavor}
        />

        <Flavor
          data={pbCup}
          fixed={images.pbCup.childImageSharp.fixed}
          flavorIndex={5}
          activeFlavor={activeFlavor}
          setActiveFlavor={setActiveFlavor}
          incomingFlavor={incomingFlavor}
        />
      </CardRow>
    </>
  )
}
